import React from "react";
// SCSS
import "./partnerBox.scss";

const partnerBox2 = (props) => (
  <div className="partner__box flex-center">
    <img src={props.partner} alt="partner"       style={{ width: "70px", height: "150px", objectFit: "contain" }} />
  </div>
);

export default partnerBox2;
